/**
 * Reads the Rewardful referral ID from the rw_ref cookie.
 * @returns {string | null}
 */
export function getRewardfulReferral() {
    if (typeof document === "undefined") return null;
    const match = document.cookie.match('(^|;)\\s*rw_ref\\s*=\\s*([^;]+)');
    return match ? decodeURIComponent(match.pop() || "") : null;
}

export function loadRewardfulScript(siteId: string) {
  if (typeof document === 'undefined') return;
  // Avoid duplicating the script
  if (document.querySelector('script[data-rewardful]')) return;

  // Create the queue shim so Rewardful calls don't error before load
  (function (w: any, r: string) {
    w._rwq = r;
    w[r] = w[r] || function () {
      (w[r].q = w[r].q || []).push(arguments);
    };
  })(window as any, 'rewardful');

  const src = 'https://r.wdfl.co/rw.js';

  // Directly inject the script tag (no prefetch) to avoid CORS noise
  const script = document.createElement('script');
  script.async = true;
  script.src = src;
  script.setAttribute('data-rewardful', siteId);
  // Do not set crossOrigin: it's not needed for simple script load and can surface errors
  script.onerror = () => {
    // Silently ignore client-side blockers
    if (import.meta.env.DEV) {
      console.warn('Rewardful script blocked or unavailable.');
    }
  };
  document.head.appendChild(script);
}